import { TSelectOption } from "common/Select/Select.interface";
import {
  IPromotionForm,
  TRestrictionType,
  ExclusionLabel,
  EOrderRestrictionType,
} from "store/reducers/promotion.reducers";
import { restrictionNoDisableFields, ECampaignStatus } from "store/store.interface";

const mutualFieldsMapping: any = {
  sellerType: "shipmentType",
  shipmentType: "sellerType",
};

export const filterAlreadySelectedRestriction = (
  options: TSelectOption[],
  restrictionFieldsNames: string[]
) => {
  return options.filter((option) => {
    return restrictionFieldsNames.indexOf(option.value) === -1;
  });
};

export const filterAlternateRestriction = (
  options: TSelectOption[],
  restrictionFieldsNames: string[]
) => {
  return options.filter((option) => {
    const restrictedField = mutualFieldsMapping[option.value];
    return !(restrictionFieldsNames.indexOf(restrictedField) > -1);
  });
};

export const isEditingPausedCampaign = (creationForm: IPromotionForm) => {
  return creationForm.edit && creationForm.status === ECampaignStatus.paused;
};

export const filterRestrictionForPausedCampaign = (
  field: TRestrictionType,
  creationForm: IPromotionForm
) => {
  const option = { label: field.label, value: field.name };

  if (isEditingPausedCampaign(creationForm)) {
    if (field.type === "file" || field.name === 'numberOfUsage' || field.name === 'budget') {
      return option;
    } else {
      return { label: "", value: "" };
    }
  }

  return option;
};

export const overrideRestrictionDisable = (
  restriction: TRestrictionType,
  creationForm: IPromotionForm,
  disable: boolean
) => {
  const { name, type } = restriction;
  if (
    restrictionNoDisableFields.includes(name) ||
    (isEditingPausedCampaign(creationForm) && type === "file")
  ) {
    return false;
  }

  return disable;
};

export const isConflictingRestrictionSet = (
  field: Pick<TRestrictionType, "name" | "restrictionType">,
  restrictions: Record<string, any> = {}
): boolean => {
  const stored = restrictions[field.name];
  if (!stored) return false;
  if (field.restrictionType === EOrderRestrictionType.Exclusion) {
    return (
      (stored?.op === ExclusionLabel.in && stored?.value?.length > 0) ||
      (Array.isArray(stored) && stored.length > 0)
    );
  }
  if (field.restrictionType === EOrderRestrictionType.Inclusion) {
    return stored?.op === ExclusionLabel.notIn && stored?.value?.length > 0;
  }
  return false;
};
